
export default ({ filters, items }) => {
  const wasQuoted = filters.wasQuoted
  const wasNotAssociated = filters.wasNotAssociated
  const wasAssociated = filters.wasAssociated
  const haveProposal = filters.haveProposal
  const haveSearchText = filters.searchText.trim().length > 0

  const haveColumnFilterStrictToME = filters.columnFilters.strictToME.filterValue.length > 0
  const haveColumnFilterPriceGuaranted = filters.columnFilters.isPriceGuaranted.filterValue.length > 0

  const haveColumnFilterNumber = filters.columnFilters.number.filterValue.length > 0
  const haveColumnFilterQuotesMap = filters.columnFilters.quotationMap.filterValue.length > 0
  const haveColumnFilterDescription = filters.columnFilters.description.filterValue.length > 0
  const haveColumnFilterUnity = filters.columnFilters.unity.filterValue.length > 0

  const haveColumnFilterCostLab = filters.columnFilters.costLab.filterValue.length > 0
  const haveColumnFilterCostUnit = filters.columnFilters.costUnit.filterType !== '0'
  const haveColumnFilterCostTotal = filters.columnFilters.costTotal.filterType !== '0'

  const haveColumnFilterMaxLab = filters.columnFilters.maxLab.filterValue.length > 0
  const haveColumnFilterMaxUnit = filters.columnFilters.maxUnit.filterType !== '0'
  const haveColumnFilterMaxTotal = filters.columnFilters.maxTotal.filterType !== '0'
  const haveColumnFilterMaxPerc = filters.columnFilters.maxPerc.filterType !== '0'

  const haveColumnFilterEstimatedUnit = filters.columnFilters.estimatedUnit.filterType !== '0'
  const haveColumnFilterEstimatedTotal = filters.columnFilters.estimatedTotal.filterType !== '0'
  const haveColumnFilterEstimatedPerc = filters.columnFilters.estimatedPerc.filterType !== '0'

  const haveColumnFilterSaleUnit = filters.columnFilters.saleUnit.filterType !== '0'
  const haveColumnFilterSaleTotal = filters.columnFilters.saleTotal.filterType !== '0'
  const haveColumnFilterSalePerc = filters.columnFilters.salePerc.filterType !== '0'

  const haveColumnFilterMinimumUnit = filters.columnFilters.minimumUnit.filterType !== '0'
  const haveColumnFilterMinimumTotal = filters.columnFilters.minimumTotal.filterType !== '0'
  const haveColumnFilterMinimumPerc = filters.columnFilters.minimumPerc.filterType !== '0'

  const haveColumnFilter =
    haveColumnFilterNumber ||
    haveColumnFilterStrictToME ||
    haveColumnFilterPriceGuaranted ||
    haveColumnFilterQuotesMap ||
    haveColumnFilterDescription ||
    haveColumnFilterUnity ||
    haveColumnFilterCostUnit ||
    haveColumnFilterCostLab ||
    haveColumnFilterCostTotal ||
    haveColumnFilterMaxLab ||
    haveColumnFilterMaxUnit ||
    haveColumnFilterMaxTotal ||
    haveColumnFilterMaxPerc ||
    haveColumnFilterEstimatedUnit ||
    haveColumnFilterEstimatedTotal ||
    haveColumnFilterEstimatedPerc ||
    haveColumnFilterSaleUnit ||
    haveColumnFilterSaleTotal ||
    haveColumnFilterSalePerc ||
    haveColumnFilterMinimumUnit ||
    haveColumnFilterMinimumTotal ||
    haveColumnFilterMinimumPerc

  if (!wasNotAssociated &&
    !wasQuoted &&
    !wasAssociated &&
    !haveProposal &&
    !haveSearchText &&
    !haveColumnFilter) {
    return [ ...items ]
  }

  const filteredList = items.filter(i => {
    const filtersFields = {
      number: i.itemInfo && i.itemInfo.number,
      strictToME: i.itemInfo && i.itemInfo.strictToME,
      isPriceGuaranted: i.quoted && i.quoted.isPriceGuaranted,
      quotationMap: i.quotationMap,
      description: i.itemInfo && i.itemInfo.description,
      unity: i.itemInfo && i.itemInfo.unity,
      costLab: (i.quoted && i.quoted.lab) || (i.associated && i.associated.lab),
      costUnit: (i.quoted && i.quoted.price) || (i.associated && i.associated.price),
      costTotal: (i.quoted && i.quoted.priceTotal) || (i.associated && i.associated.priceTotal),
      maxLab: i.quoted && i.quoted.cmedLab,
      maxUnit: i.quoted && i.quoted.cmedPrice,
      maxTotal: i.quoted && i.quoted.cmedTotalPrice,
      maxPerc: i.quoted && i.quoted.cmedPerc && Number(i.quoted.cmedPerc),
      estimatedUnit: i.itemInfo && i.itemInfo.estimatedPrice,
      estimatedTotal: i.itemInfo && i.itemInfo.estimatedTotalPrice,
      estimatedPerc: i.itemInfo && i.itemInfo.estimatedPerc && Number(i.itemInfo.estimatedPerc),
      saleUnit: i.quoted && i.quoted.proposalPrice,
      saleTotal: i.quoted && i.quoted.proposalTotalPrice,
      salePerc: i.quoted && i.quoted.proposalPerc && Number(i.quoted && i.quoted.proposalPerc),
      minimumUnit: i.quoted && i.quoted.minimumPrice,
      minimumTotal: i.quoted && i.quoted.minimumTotalPrice,
      minimumPerc: i.quoted && i.quoted.minimumPerc && Number(i.quoted && i.quoted.minimumPerc)
    }

    let allFiltersPasses = true
    for (const filterField in filtersFields) {
      const isFieldCompare = filters.columnFilters[filterField].filterType === 'fieldCompare'
      const isFilterOption = filters.columnFilters[filterField].filterType === 'BOOLEAN'
      const isFilterList = filters.columnFilters[filterField].filterType !== '0' &&
        filters.columnFilters[filterField].filterType !== 'fieldCompare' &&
        Array.isArray(filters.columnFilters[filterField].filterValue) &&
        filters.columnFilters[filterField].filterValue.length > 0
      const isFilterType = filters.columnFilters[filterField].filterType !== '0' &&
        filters.columnFilters[filterField].filterType !== 'fieldCompare' &&
        filters.columnFilters[filterField].filterType !== 'LIST'

      if (!isFilterOption && (isFilterList || isFilterType)) {
        const isFilterPassed = filtersFields[filterField] &&
          filtersFields[filterField].toString().trim().length > 0 &&
          filterByValueWithType({
            valueOfItem: filtersFields[filterField],
            valueToFilter: filters.columnFilters[filterField].filterValue,
            filterType: filters.columnFilters[filterField].filterType
          })

        if (!isFilterPassed) {
          allFiltersPasses = false
        }
      }

      if (isFilterOption) {
        const isFilterOptionPassed = filterByValueWithType({
          valueOfItem: filtersFields[filterField],
          valueToFilter: filters.columnFilters[filterField].filterValue,
          filterType: filters.columnFilters[filterField].filterType})

        if (!isFilterOptionPassed) {
          allFiltersPasses = false
        }
      }
      if (isFieldCompare) {
        if (
          filters.columnFilters[filterField].filterValue[0] === 'cmedgteestimated' &&
          filtersFields.maxUnit < filtersFields.estimatedUnit) {
          allFiltersPasses = false
        } else if (
          filters.columnFilters[filterField].filterValue[0] === 'cmedlteestimated' &&
          filtersFields.maxUnit > filtersFields.estimatedUnit) {
          allFiltersPasses = false
        }
      }
    }

    if (haveSearchText) {
      // Filtering By Text
      const regSearch = new RegExp(filters.searchText.trim(), 'gi')
      if (!isNaN(Number(filters.searchText.trim())) && Number(filters.searchText.trim()) !== Number(i.itemInfo.number)) {
        return false
      }
      if (!regSearch.test(i.itemInfo.description)) {
        return false
      }
    }

    // Filtering by Flag
    if (wasNotAssociated && i.associated.isAssociated) {
      return false
    }

    if (wasAssociated && !i.associated.isAssociated) {
      return false
    }

    if (wasQuoted && !i.quoted.isQuoted) {
      return false
    }

    if (haveProposal && !i.quoted.haveProposal) {
      return false
    }

    // Dynamic Items Filter
    for (const dynamicFilter in filters.dynamicColumnFilter) {
      const valueOfItem = i.dynamicColumns[dynamicFilter].value
      const valueToFilter = filters.dynamicColumnFilter[dynamicFilter].filterValue
      const filterType = filters.dynamicColumnFilter[dynamicFilter].filterType
      const filteredPassed = filterByValueWithType({
        valueOfItem,
        valueToFilter,
        filterType
      })

      if (!filteredPassed) { allFiltersPasses = false }
    }

    return allFiltersPasses
  })

  return filteredList
}

const filterByValueWithType = ({ valueOfItem, valueToFilter, filterType }) => {
  switch (filterType) {
    case 'KEY':
      let res = false
      for (const filterKey of valueToFilter) {
        if (valueOfItem[filterKey] && valueOfItem[filterKey] > 0) {
          res = true
          break
        }
      }
      return res
    case 'LIST':
      return valueToFilter.includes(valueOfItem.toString())
    case 'LIKE':
      const regEx = new RegExp(valueToFilter, 'gi')
      return regEx.test(valueOfItem)
    case 'EQ':
      return valueOfItem.toString() === valueToFilter.toString()
    case 'GT':
      return compareGT(valueOfItem, valueToFilter)
    case 'LT':
      return compareLT(valueOfItem, valueToFilter)
    case 'BOOLEAN':
      if (valueToFilter.includes('FALSE') && !valueOfItem) { return true }
      if (valueToFilter.includes('TRUE') && valueOfItem) { return true }
      return false
    default:
      return false
  }
}

const compareGT = (item, filter) => {
  const vItem = !isNaN(Number(item)) ? Number(item) : convertBRCurrencyToNumber(item)
  const vFilter = !isNaN(Number(filter)) ? Number(filter) : convertBRCurrencyToNumber(filter)
  return vItem > vFilter
}
const compareLT = (item, filter) => {
  const vItem = !isNaN(Number(item)) ? Number(item) : convertBRCurrencyToNumber(item)
  const vFilter = !isNaN(Number(filter)) ? Number(filter) : convertBRCurrencyToNumber(filter)
  return vItem < vFilter
}

const convertBRCurrencyToNumber = (v) => {
  return Number(v
    .toString()
    .replace('.', '')
    .replace(',', '.'))
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/FilterItems.js